import { PREP_OVERLAY } from './styles'
import { Typography } from '@mui/material';
import { styled } from '@mui/system';

const OverlayDiv = styled('div')({
  ...PREP_OVERLAY,
});

const ScenePreparingOverlay = () => {

  return (
      <OverlayDiv>
        <Typography sx={{fontWeight: 500, opacity: 1}}>
          {"Sit tight! We're taking you to your room..."}
        </Typography>
      </OverlayDiv>
  )
}

export default ScenePreparingOverlay
